"use client";

import useResponsiveSize from "@/hooks/useResponsiveSize";
import { useAutoTranslate } from "@/lib/i18n/useAutoTranslate";
import { Button as AntdButton } from "antd";
import React from "react";
import { ButtonProps } from "./types";

const Button: React.FC<ButtonProps> = (props) => {
  const {
    type = "default",
    size,
    shape,
    icon,
    loading,
    disabled,
    danger,
    ghost,
    children,
    htmlType = "button",
    onClick,
    className = "w-full",
    style,
    block,
    href,
    target,
    filled,
    ...rest
  } = props;
  const responsiveSize = useResponsiveSize();
  const tr = useAutoTranslate();

  const translatedChildren =
    typeof children === "string"
      ? tr(children)
      : Array.isArray(children)
        ? children.map((child) => (typeof child === "string" ? tr(child) : child))
        : children;

  return (
    <AntdButton
      type={type}
      size={size || responsiveSize}
      shape={shape}
      icon={icon}
      loading={loading}
      disabled={disabled}
      danger={danger}
      ghost={ghost}
      htmlType={htmlType}
      onClick={onClick}
      className={className}
      style={style}
      block={block}
      href={href}
      target={target}
      {...rest}
    >
      {translatedChildren}
    </AntdButton>
  );
};

export default Button;
